/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for calculatedMemberTypeEnum. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="calculatedMemberTypeEnum"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="simpleCalc"/&gt; &lt;enumeration value="dbCalc"/&gt; &lt;enumeration value="xCalc"/&gt; &lt;enumeration value="xCalcWithChild"/&gt; &lt;enumeration value="xCalcWithFormula"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class CalculatedMemberTypeEnum extends Enum{

	enumValue = null;

	/**
	 * Simple calculated member.
	 */
	static  SIMPLE_CALC = CalculatedMemberTypeEnum.newLiteral("simpleCalc");

	/**
	 * Database calculated member.
	 */
	static  DB_CALC = CalculatedMemberTypeEnum.newLiteral("dbCalc");

	/**
	 * Extended calculated member.
	 */
	static  X_CALC = CalculatedMemberTypeEnum.newLiteral("xCalc");

	/**
	 * Child-ref extended calculated member.
	 */
	static  X_CALC_WITH_CHILD = CalculatedMemberTypeEnum.newLiteral("xCalcWithChild");

	/**
	 * Extended calculated members with formula key.
	 */
	static  X_CALC_WITH_FORMULA = CalculatedMemberTypeEnum.newLiteral("xCalcWithFormula");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < CalculatedMemberTypeEnum.values().length); ++i) {
			if (CalculatedMemberTypeEnum.values()[i].enumValue == v) {
				return CalculatedMemberTypeEnum.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("CalculatedMemberTypeEnum" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/CalculatedMemberTypeEnum.js